import { useState, useEffect, useContext, useMemo } from 'react'
import { Heading, MetricCard } from '../components/common/atoms'
import { RoundedSelect } from '../components/tailwind/atoms'
import { handleAppError } from '../components/handlers'
import { AppDispatchContext } from '../utils/contexts'
import { ContractsManager } from '../managers'
import { utilizationApi } from '../services'
import { active_employees, totalamont, ratingsStar, Lock, arrow_tip_dark, upArrow, FullStar } from '../assets/images'
import { CardSlider } from '../components/tailwind/molecules'
import { OverviewApi } from '../services'
import { commaingNumber, computeRating } from '../utils'
import { HealthChallengeCard, OverviewServiceCard, StepsCard, WellnessCalendarCard } from '../components/tailwind/organisms'
import { BENEFITS, NOT_ENABLED_BENEFITS, RELEASE_DATE } from '../constants/overview'
import { UserAlert } from '../components/common/atoms/alerts'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const SPONSORED = 'sponsored'
const NON_SPONSORED = 'non-sponsored'

const Overview = () => {
  const [state, setState] = useState({ notSponsoredConsultation: false, contractDetails: {}, enabledBenefits: {}, notEnabledServices: [], benefitsUtilizationPercentage: { hra: 1000, pre_employment: 999 }, openModel: false })
  const dispatch = useContext(AppDispatchContext)
  const history = useHistory()

  const hrFirstName = useMemo(() => {
    const hr_name = sessionStorage.getItem('hr_name')
    if(!hr_name) return ''

    let hrName = hr_name.split(' ')
    return hrName.length > 0 ? hrName[0] : ''
  }, [])

  const setSubState = (newState) => {
    setState(prevState => { return {...prevState, ...newState} })
  }

  useEffect(() => {
    fetchContractDetails()
  }, [])

  const setUilizationToBenefit = (type, benefitType, percentage) => {
    if(!BENEFITS.includes(benefitType)) return

    let { benefitsUtilizationPercentage = {} } = state

    if(benefitsUtilizationPercentage[benefitType] === percentage) return

    benefitsUtilizationPercentage[benefitType] = percentage
    setSubState({ benefitsUtilizationPercentage })

    sortBenefitsByUtilization(type, benefitsUtilizationPercentage)
  }

  const sortBenefitsByUtilization = (type, benefitsUtilizationPercentage) => {
    benefitsUtilizationPercentage = benefitsUtilizationPercentage ?? state.benefitsUtilizationPercentage

    if(type === SPONSORED) {
      let { sponsoredBenefits = [] } = state.enabledBenefits
      sponsoredBenefits = sponsoredBenefits.sort((a, b) => (benefitsUtilizationPercentage[b] ?? 0) - (benefitsUtilizationPercentage[a] ?? 0))

      setSubState({ enabledBenefits: {...state.enabledBenefits, sponsoredBenefits} })
    } else if(type === NON_SPONSORED) {
      let { nonSponsoredBenefits = [] } = state.enabledBenefits
      nonSponsoredBenefits = nonSponsoredBenefits.sort((a, b) => (benefitsUtilizationPercentage[b] ?? 0) - (benefitsUtilizationPercentage[a] ?? 0))

      setSubState({ enabledBenefits: {...state.enabledBenefits, nonSponsoredBenefits} })
    }
  }

  const fetchContractDetails = async () => {
    await utilizationApi.fetchContracts({},
      (resp) => {
        var contractObj = new ContractsManager(resp.data)
        const contract_id = Number(sessionStorage.getItem('contract_id'))
        const selectedContract = contractObj.formattedData.find(item => item.contract_id === contract_id) || contractObj.formattedData[0]
        const showSpendingAccount = selectedContract.enable_spending_account
        const contractDetails = {
          contracts: contractObj.formattedData,
          selectedContract
        }
        setSubState({ contractDetails })
        dispatch({ type: '', showSpendingAccount })
        if(showSpendingAccount) {
          sessionStorage.setItem('isOPDAccount', showSpendingAccount);
          history.replace('/opd-overview')
          return
        }
        fetchOverviewInitData(selectedContract.contract_id, selectedContract.start_date, selectedContract.end_date, contractDetails)
      },
      (err) => handleAppError(err)
    )
  }

  const fetchOverviewInitData = async (contractId, startDate, endDate, contractDetails) => {
    contractDetails = contractDetails ?? state.contractDetails
    const contract_id = contractId ?? contractDetails.selectedContract.contract_id
    const start_date = startDate ?? contractDetails.selectedContract.start_date
    const end_date = endDate ?? contractDetails.selectedContract.end_date

    await OverviewApi.fetchOverviewInitData({ contract_id, start_date, end_date },
      (res) => {
        const enabledBenefits = res.data.enabled_benefits ?? []

        let sponsoredBenefits = enabledBenefits.filter(item => item.primary === 'primary_sponsored')
        let nonSponsoredBenefits = enabledBenefits.filter(item => item.primary !== 'primary_sponsored')

        let notSponsoredConsultation = nonSponsoredBenefits.map(service => service.benefit_type).includes('consultation24x7')
        sponsoredBenefits = sponsoredBenefits.map(service => service.benefit_type === 'consultation24x7' ? 'consultations' : service.benefit_type).filter(e => BENEFITS.includes(e)) // filtering benefits that are to display
        sponsoredBenefits = ['hra', ...new Set(sponsoredBenefits.includes('pre_employment') ? ['pre_employment', ...sponsoredBenefits] : sponsoredBenefits)]

        nonSponsoredBenefits = nonSponsoredBenefits.map(service => service.benefit_type).filter(e => BENEFITS.includes(e)) // filtering benefits that are to display
        nonSponsoredBenefits = [...new Set(nonSponsoredBenefits.includes('pre_employment') ? ['pre_employment', ...nonSponsoredBenefits] : nonSponsoredBenefits)]

        if(state?.contractDetails?.selectedContract?.contract_id !== contract_id) {
          contractDetails = {
            ...contractDetails,
            selectedContract: contractDetails?.contracts?.find(item => item.contract_id === contract_id)
          }
          setSubState({ enabledBenefits: { sponsoredBenefits, nonSponsoredBenefits }, notSponsoredConsultation: notSponsoredConsultation, contractDetails })
        } else setSubState({ enabledBenefits: { sponsoredBenefits, nonSponsoredBenefits }, notSponsoredConsultation: notSponsoredConsultation })

        callApis(contract_id, start_date, end_date)
      },
      (err) => handleAppError(err)
    )
  }

  const callApis = (contractId, startDate, endDate) => {
    fetchOverviewMetric(contractId, startDate, endDate)
    fetchOverviewCostAndRatings(contractId, startDate, endDate)
    fetchNotEnabledServices(contractId, startDate, endDate)
  }

  const fetchOverviewMetric = async (contractId, startDate, endDate) => {
    const contract_id = contractId || state.contractDetails.selectedContract.contract_id
    const start_date = startDate || state.contractDetails.selectedContract.start_date
    const end_date = endDate || state.contractDetails.selectedContract.end_date

    await OverviewApi.fetchOverviewMetric({ contract_id, start_date, end_date },
      (res) => {
        setSubState({...res.data})
      },
      (err) => handleAppError(err)
    )
  }

  const fetchOverviewCostAndRatings = async (contractId, startDate, endDate) => {
    const contract_id = contractId || state.contractDetails.selectedContract.contract_id
    const start_date = startDate || state.contractDetails.selectedContract.start_date
    const end_date = endDate || state.contractDetails.selectedContract.end_date

    await OverviewApi.fetchOverviewCostAndRatings({ contract_id, start_date, end_date },
      (res) => {
        setSubState({...res.data})
      },
      (err) => handleAppError(err)
    )
  }

  const fetchNotEnabledServices = async (contract_id, start_date, end_date) => {
    contract_id = contract_id || state.contractDetails.selectedContract.contract_id
    start_date = start_date || state.contractDetails.selectedContract.start_date
    end_date = end_date || state.contractDetails.selectedContract.end_date

    await OverviewApi.fetchNotEnabledServices({ contract_id, start_date, end_date },
      (resp) => {
        setSubState({
          notEnabledServices: resp.data || []
        })
      },
      (err) => {
        handleAppError(err)
      }
    )
  }

  const changeContractTo = (contractId) => {
    const contract = state.contractDetails.contracts.find((item) => item.contract_id == contractId)
    sessionStorage.setItem('contract_id', contract.contract_id);
    const showSpendingAccount = contract.enable_spending_account
    if(showSpendingAccount) {
      sessionStorage.setItem('isOPDAccount', showSpendingAccount);
      history.replace('/opd-overview')
      return
    }
    fetchOverviewInitData(contract.contract_id, contract.start_date, contract.end_date)
  }

  const toggleModal = () => setSubState({ openModel: !state.openModel })

  const { contractDetails: { contracts = [], selectedContract = {} }, notEnabledServices = [], enabledBenefits: { sponsoredBenefits = [], nonSponsoredBenefits = []},
          active_customers_count = 0, onboarded_customers_count = 0, total_spendings = 0, total_ratings = 0, notSponsoredConsultation = false } = state
  const { contract_id: selectedContractId, start_date: selectedContractStartDate, end_date: selectedContractEndDate, is_running_contract: isRunningContract, uuid: selectedContractUuid } = selectedContract
  const totalSpendings = commaingNumber(total_spendings)
  const totalVerifiedRating = Object.values(total_ratings).reduce((a,b) => a + b, 0)
  const [totalRating, verifiedRatings] = computeRating(total_ratings)
  const utilizationPercentage = active_customers_count > 0 ? (onboarded_customers_count / active_customers_count) * 100 : 0
  const notEnabledServicesKeys = Object.keys(NOT_ENABLED_BENEFITS)
  const filteredNotEnabledServices = notEnabledServices.filter(e => notEnabledServicesKeys.includes(e.service))
  const noOfNotEnabledServices = filteredNotEnabledServices.length
  const renderState = localStorage.getItem('lastupdated')  === RELEASE_DATE
  const notEnabledServicesData = filteredNotEnabledServices.map((item) => 
    <MetricCard
      loading={false}
      loaderHeight={120}
      svgsrc={NOT_ENABLED_BENEFITS[item.service]['icon']}
      title={ <span className='font-semibold text-lg text-gray-700'>{NOT_ENABLED_BENEFITS[item.service]['service_type']}</span> }
      subTitle = {<div className='flex flex-row items-center mb-2'> <img className='h-3.5 w-3.5 mr-1' src={FullStar} alt='rating star'/> <span className='font-semibold text-base text-gray-600'>{item.rating}</span>/5 {`(${item.verified_ratings} verified ratings`})</div>}
      subTitleClasses = 'text-gray-600 font-normal text-sm ml-1'
      metricValue={<p className='text-sm font-normal text-gray-600'><span className='font-semibold text-base text-gray-600'>{commaingNumber(item.total_utilization)}</span> {`total ${NOT_ENABLED_BENEFITS[item.service]['tag']} availed in last one year`}</p>}
      classes={`w-90 inline-block m-3 flex-1 h-36`} metricClasses = 'flex' headerClasses='px-6 py-4' svgClasses='h-8 w-8 mb-4'
    />
  ) 

  return (
    <div className={noOfNotEnabledServices > 0 ? 'mb-20' : ''}>
      <div  
        onClick={() => {
          localStorage.setItem('lastupdated', RELEASE_DATE)
          window.location.reload(true);
          }
        }   
      >
        { !renderState && 
          <UserAlert
            icon='yellow'
            para={<span className='text-base font-semibold text-gray-700 leading-5'> New Update available. <span className='text-blue-500 font-semibold'>Click here</span> to load latest update.</span>}
            btntext='Refresh page'
            btnHandler={() => {
              localStorage.setItem('lastupdated', RELEASE_DATE)
              window.location.reload(true);
              }
            }
            classes='border border-red-600 py-3 px-4 mt-8'
            paraClasses='text-gray-700 leading-4 font-semibold '        
          />
        }  
      </div>
      <div className='flex justify-between items-center mt-6'>
        <Heading mainHeading='Overview' subHeading={`Hi ${hrFirstName}, Track utilisation & analytics of all the enabled benefits`} s subClasses='mt-1 text-sm text-gray-600' />
        <RoundedSelect
          listClasses='w-56'
          selectOptions={contracts.map(i => i.text)}
          selectValues={contracts.map(i => i.contract_id)}
          curvalue={contracts.find(i => i.contract_id === selectedContractId)?.text}
          selectHandler={changeContractTo}
        />
      </div>
      <div className='mt-7 grid grid-cols-3 gap-6'>
        <MetricCard
          title='Activation percentage'
          titleClasses='font-semibold text-gray-700 text-base'
          subTitle='Percentage of employees who logged in at least once on the ekincare app'
          subTitleClasses='font-normal text-xs caret-gray-600'
          metricValue={<span className='font-semibold text-3xl text-gray-900 ml-11'>{Math.round(utilizationPercentage)}%</span>} 
          metricValueSuffix={<><span className='font-fig-normal text-sm text-gray-500'>{commaingNumber(onboarded_customers_count)}</span> <span className='text-gray-500 font-fig-normal text-xs'>/ {commaingNumber(active_customers_count)} employees</span></>}
          metricClasses='flex mt-6 mb-0 text-gray-600'
          svgsrc={active_employees} 
          svgClasses='h-8 w-8 mb-5'
        />
        { !!totalSpendings &&
          <MetricCard
            title='Total amount spent'
            titleClasses='font-semibold text-gray-700 text-base'
            subTitle='The amount spent on the sponsored services on your current plan'
            subTitleClasses='font-normal text-xs caret-gray-600'
            metricValue={<span className='font-semibold text-3xl text-gray-900 ml-11'>₹{totalSpendings}</span>}
            metricClasses='flex mt-6 mb-0'
            svgsrc={totalamont}
            svgClasses='h-8 w-8 mb-5'
          />
        }
        { !!verifiedRatings && 
          <MetricCard
            title='Overall rating'
            titleClasses='font-semibold text-gray-700 text-base'
            subTitle='Average of the ratings across the service lines'
            subTitleClasses='font-normal text-xs caret-gray-600'
            metricValue={<span className='font-semibold text-3xl text-gray-900 ml-11'>{totalRating}<span className='text-xl font-semibold'>/5</span></span>}
            metricClasses='flex mt-6 mb-0 mt-10'
            metricValueSuffix={<><span className='font-semibold text-xs text-gray-500'>{commaingNumber(totalVerifiedRating)} verified ratings</span></>}
            svgsrc={ratingsStar}
            svgClasses='h-8 w-8 mb-2'
          />
        }
      </div>
      {sponsoredBenefits.map((item, index) => {
        return <OverviewServiceCard  key={item + index} classes='mt-6' benefitType={item} contractId={selectedContractId} startDate={selectedContractStartDate} endDate={selectedContractEndDate} contractUuid={selectedContractUuid} totalCustomerCount={active_customers_count} isRunningContract={isRunningContract}  setUilizationToBenefit={setUilizationToBenefit.bind('', SPONSORED, item)} />
      })}
      {notSponsoredConsultation ? <OverviewServiceCard  key={'consultations999'} classes='mt-6' benefitType='consultations' contractId={selectedContractId} startDate={selectedContractStartDate} endDate={selectedContractEndDate} contractUuid={selectedContractUuid} totalCustomerCount={active_customers_count} isRunningContract={isRunningContract} setUilizationToBenefit={setUilizationToBenefit.bind('', SPONSORED, 'consultations')} /> : null }
      <WellnessCalendarCard classes='mt-6' contractId={selectedContractId} startDate={selectedContractStartDate} endDate={selectedContractEndDate} />
      {nonSponsoredBenefits.map((item, index) => {
        return <OverviewServiceCard  key={item + index} classes='mt-6' benefitType={item} contractId={selectedContractId} startDate={selectedContractStartDate} endDate={selectedContractEndDate} contractUuid={selectedContractUuid} totalCustomerCount={active_customers_count} setUilizationToBenefit={setUilizationToBenefit.bind('', NON_SPONSORED, item)} />
      })}
      <HealthChallengeCard classes='mt-6' contractId={selectedContractId} startDate={selectedContractStartDate} endDate={selectedContractEndDate} totalCustomerCount={active_customers_count} />
      <StepsCard classes='mt-6' contractId={selectedContractId} startDate={selectedContractStartDate} endDate={selectedContractEndDate} totalCustomerCount={active_customers_count} />
      { noOfNotEnabledServices > 0 && 
        <div className='bg-white fixed ml-64 bottom-0 z-30 right-0 left-0' style={{ boxShadow: '0 -5px 6px -1px rgb(0 0 0 / 10%)' }}>
          <div className='bg-yellow py-4 flex flex-auto justify-between cursor-pointer' style={{ backgroundColor: '#FEFBED' }} onClick={toggleModal}>
            <span className='flex flex-auto'>
              <img className='h-8 w-8 ml-6' src={Lock}/>
              <span className='font-semibold text-xl text-gray-900 ml-4 mt-1'>{`${noOfNotEnabledServices} ${noOfNotEnabledServices > 1 ? 'Services' : 'Service'} not enabled`}</span>
            </span>
            <img className='mr-6' src={`${state.openModel ? upArrow : arrow_tip_dark }`} alt='down arrow' />
          </div>
          { state.openModel && <CardSlider classes='p-2' data={notEnabledServicesData} slidesToShow={3} slidesToScroll={3} /> }
        </div>
      }
    </div>
  )
}

export default Overview